import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "emptyText",
})
export class EmptyTextPipe implements PipeTransform {
  transform(value: string, emptyText = "-") {
    if (!value) return emptyText;
    return value;
  }
}
